import styled from "styled-components";

export const StyledUserModalContainer = styled.div`
  width: 56rem;
  display: flex;
  flex-flow: column nowrap;
  gap: 0.4rem;
  background-color: var(--bg-gray-0);
  .area {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--bg-gray-normal);
    padding: 1.6rem;
    gap: 1.2rem;
    .field-area {
      width: max-content;
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      .label-area {
        width: 26rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .label {
          display: flex;
          font: var(--label-medium-400);
          color: var(--text-gray-strong);
          span {
            color: var(--sys-red-1);
          }
          &.error {
            color: var(--sys-red-1);
          }
        }
      }
    }
    .group-area {
      display: flex;
      flex-flow: column nowrap;
      gap: 0.4rem;
    }
    &.row {
      flex-direction: row;
      gap: 0.8rem;
    }
  }
`;
